// project imports
import { withAlpha } from 'utils/colorUtils';
import { THEME_COLOR_CONFIG } from 'config/themeColors';

// ==============================|| OVERRIDES - TAB ||============================== //

export default function Tab(theme) {
  const baseBg = withAlpha(
    theme.vars.palette.primary.main,
    theme.palette.mode === 'dark'
      ? THEME_COLOR_CONFIG.selection.baseBgAlphaDark
      : THEME_COLOR_CONFIG.selection.baseBgAlphaLight
  );
  const hoverBg = withAlpha(
    theme.vars.palette.primary.main,
    theme.palette.mode === 'dark'
      ? THEME_COLOR_CONFIG.selection.hoverBgAlphaDark
      : THEME_COLOR_CONFIG.selection.hoverBgAlphaLight
  );

  return {
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 46,
          color: theme.vars.palette.text.primary,
          borderRadius: 4,
          backgroundColor: baseBg,
          '&:hover': {
            backgroundColor: hoverBg,
            color: theme.vars.palette.primary.main
          },
          '&.Mui-selected': {
            color: theme.vars.palette.primary.main,
            backgroundColor: baseBg
          },
          '&.Mui-selected:hover': {
            backgroundColor: hoverBg
          },
          '&:focus-visible': {
            borderRadius: 4,
            outline: `2px solid ${theme.vars.palette.secondary.dark}`,
            outlineOffset: -3
          }
        }
      }
    }
  };
}
